import { $GET } from '@/api/gateway/gatewayMethods';
import { APP_RESOURCES } from '@/api/endpoint-defines/resource';

export const getAppResourceApi = () =>
  $GET({ EndPoint: APP_RESOURCES, QueryParameters: null });
